module.exports = __webpack_public_path__ + "static/mouse-middle.5aa6822c8f2947c9a03718cf2074fbc0.svg";